import { Table, Card, Button, Form, Input, Checkbox, message, Divider, Popconfirm } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import React, { Component, Fragment } from 'react';
import { menu_list } from '../../utils/menu';
import { PostForm } from '../../utils/http';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};
class UserRole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      roleIds: [],
      addModal: undefined,
      tableloading: false,
      modalloading: false,
      authOptions: [],
    };
  }
  componentDidMount() {
    this.getData();
    const authOptions = [{ label: '所有权限', value: 'S' }];
    menu_list.forEach(item => {
      item.children.forEach(({ title, auth }) => {
        // const auth_tl = (auth_title || title).split(',');
        // const auth_id = auth.split(',');
        console.log("AUTH", auth);
        auth.forEach((a, idx) => {
          authOptions.push({ label: a.title, value: a.key });
        });
      })
    });
    console.log("authOptions", authOptions);
    this.setState({ authOptions });
  }
  columns = [
    {
      title: 'roleId',
      dataIndex: 'roleId',
    },
    {
      title: 'roleName',
      dataIndex: 'roleName',
    },
    {
      title: 'authIds',
      dataIndex: 'authIds',
      render: text => {
        if (!text) return text;
        return text.map(item => {
          const { label } = this.state.authOptions.find(it => it.value === item) || {};
          return label || text;
        }).join(', ');
      },
    },
    {
      title: '操作',
      render: (record) => (
        <Fragment>
          <span className="link" onClick={() => this.setState({ addModal: record })}>编辑</span>
          <Divider type="vertical" />
          <Popconfirm
            placement="leftTop"
            title="确定要删除吗?"
            onConfirm={() => this.handleDelete(record.roleId)}
            okText="确定"
            cancelText="取消"
          >
            <span className="link">删除</span>
          </Popconfirm>
        </Fragment>
      )
    },
  ]
  showAddUserModal = () => {
    this.setState({ addModal: {} });
  }
  handleDelete = (roleId) => {
    PostForm({
      url: '/api/user/deleteRole',
      data: { roleId },
      success: ({ msg }) => {
        message.success(msg);
        this.getData();
      },
      error: ({ msg }) => {
        message.error(msg);
      },
    });
  }
  onFinish = (values) => {
    const { roleId, roleName, authIds } = values;
    this.setState({ modalloading: true });
    PostForm({
      url: '/api/user/editRole',
      data: { roleId, roleName, authIds: authIds.join() },
      success: ({ msg = '操作成功' }) => {
        message.success(msg);
        this.setState({ addModal: false });
        this.getData();
      },
      error: ({ msg = '操作失败' }) => {
        message.error(msg);
      },
      final: () => {
        this.setState({ modalloading: false });
      },
    });
  }
  getData = () => {
    this.setState({ tableloading: true });
    PostForm({
      url: '/api/user/getAllRoles',
      data: {},
      success: ({ data: { roleIds } = {} }) => {
        this.setState({ roleIds })
      },
      final: () => {
        this.setState({ tableloading: false });
      },
    });
  }
  render() {
    const { roleIds, addModal, tableloading, modalloading, authOptions = [] } = this.state;
    return (
      <Card extra={
        <Button type="primary" size="small" onClick={this.showAddUserModal}>
          新增
        </Button>}
      >
        <Table
          dataSource={roleIds}
          loading={tableloading}
          columns={this.columns}
          pagination={false}
          rowKey="id"
          size="small"
        />
        {
          addModal && (
            <Modal
              visible={true}
              onCancel={() => { this.setState({ addModal: false }) }}
              footer={null}
            >
              <Form
                {...layout}
                name="basic"
                initialValues={{
                  roleId: addModal.roleId || '',
                  roleName: addModal.roleName || '',
                  password: addModal.password || '',
                  authIds: addModal.authIds || [],
                }}
                onFinish={this.onFinish}
              >
                <Form.Item
                  label="角色ID"
                  name="roleId"
                  rules={[{ required: true, message: '请输入用户ID!' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="角色姓名"
                  name="roleName"
                  rules={[{ required: true, message: '请输入用户名!' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="权限"
                  name="authIds"
                  rules={[{ required: true, message: '请选择角色!' }]}
                >
                  <Checkbox.Group options={authOptions} />
                </Form.Item>
                <div style={{ textAlign: 'right', paddingRight: 30 }}>
                  <Button loading={modalloading} type="primary" htmlType="submit">
                    提交
                  </Button>
                </div>
              </Form>
            </Modal>
          )
        }
      </Card>
    )
  }
}

export default UserRole;